<template>
    <h2 class="my-6 font-weight-regular headline">
        <v-icon class="mr-3" v-text="icon"></v-icon>
        {{ value }}
    </h2>
</template>
<script>

import Snackbar from "@/components/Snackbar.vue";
import {useVuetify} from "@/composables/vuetify";
import {computed, toRef, ref, toRefs} from "vue";
import MixinIcon from "@/mixins/MixinIcon";

export default {
    name: 'InformationSystemDateAndTimeRow',
    components: {
        Snackbar
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })
        const icons = MixinIcon.data().icons

        // props of item, and green
        const {icon, value} = toRefs(props)

        return {
            icons,
            isDark,
            icon,
            value
        }

    }

}

</script>
